import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { Button, Divider, Stack } from 'rsuite'
import Image from 'next/legacy/image'
import { useRouter } from 'next/router'

import SafeTranslate from '../common/SafeTranslate'
import { imageLoader } from '../../utils/images'
import { MediaType, Product } from '../../utils/types/Product'
import useGetAnalyticsLocation from '../../services/analytics/useGetAnalyticsLocation'
import { AnalyticsSubLocation } from '../../utils/types/analytics'
import useSampleRequestModal from '../Modals/hooks/useSampleRequestModal'
import { useCyModelWithProps } from '../../services/useCyModel'

import styles from '../../styles/CustomButtons.module.less'
import productStyles from '../../styles/Product.module.less'

interface FreeSamplePromotionProps {
  media: MediaType[]
  product: Product
}

const FreeSamplePromotion: FC<FreeSamplePromotionProps> = ({ media, product }) => {
  const { t } = useTranslation('modals')
  const router = useRouter()

  const analyticsDefaultLocation = useGetAnalyticsLocation(AnalyticsSubLocation.CtaElement)

  const openSampleRequestModal = useSampleRequestModal({
    analyticsLocation: analyticsDefaultLocation,
    product,
  })

  useCyModelWithProps('SingleProduct', {
    openSampleRequestModal,
    isRouterReady: router.isReady,
  })

  const { thumbnail, originalAlt: altText } = media[0] || {}

  return (
    <div>
      <Divider />
      <h4 className="margin-top-spacer-quadruple">
        {t('Request a free sample')}
      </h4>

      <Stack
        spacing={20}
        className="margin-top-spacer"
      >
        {thumbnail ? (
          <Image
            objectFit="cover"
            loader={imageLoader}
            src={thumbnail}
            layout="fixed"
            alt={altText}
            height={100}
            width={100}
          />
        ) : (
          <Image // Fallback image
            src="/graphics/secure-payment.svg"
            height={100}
            width={100}
            alt={altText}
          />
        )}
        <Stack
          direction="column"
          alignItems="flex-start"
        >
          <p className={productStyles['free-sample-request-promotion']}>
            <SafeTranslate
              i18nKey="marketing:Test first and buy later Visit any product page to request your free sample"
              components={{ b: <b /> }}
            />
          </p>
          <Button
            onClick={() => openSampleRequestModal()}
            appearance="ghost"
            className={`${styles['sample-request-button']} ${styles['custom-button']}`}
          >
            {t('products:Request sample')}
          </Button>
        </Stack>
      </Stack>
    </div>
  )
}

export default FreeSamplePromotion
